angular.module('rjmNg.directives').directive 'inviteUser', [
  () ->
    restrict: 'E'
    templateUrl: 'settings/directive.inviteUser.html'
    replace: true
    scope: {}
    controllerAs: 'view'
    bindToController: true
    controller: [
      "$routeParams"
      "Invites"
      "$scope"
      "notification"
      "$http"
      "$url"
      "userService"
      "app"
      "USER_PERMISSION"
      "Clients"
      (
        $routeParams
        Invites
        $scope
        notification
        $http
        $url
        userService
        app
        USER_PERMISSION
        Clients
      ) ->

        view = @

        view.accessOptions = USER_PERMISSION.ACCESS
        view.isSupportUser = app.isSupportUserSession()
        view.loading = false
        view.useInviteSystem = false # temporary flag until we resolve metric rights issue

        notificationMessages =
          success: "Invitation successful."
          error: "Invitation failed. Please try again."

        _init = () ->
          _initNewUserInfo()
          Clients.get($routeParams.clientId)
            .then ({properties}) ->
              {is_group_store_access} = properties
              view.isAdvancedUserMng = is_group_store_access is "1"
              if view.isAdvancedUserMng
                fetchOptionsFromAPI()

        _initNewUserInfo = () ->
          view.userName = null
          view.selectedAccess = USER_PERMISSION.ACCESS.STANDARD
          view.userData =
            email: null
            client_id: $routeParams.clientId
            client_rights: 
              billing: 0
              technical: 0
            access_groups: []
          
          view.inviteUserForm.$setPristine()

        view.saveUser = () ->
          notification.clear("invite-user")
          view.loading = true
          angular.extend view.userData.client_rights,
            admin: if view.selectedAccess is USER_PERMISSION.ACCESS.ADMIN then 1 else 0
            readonly: if view.selectedAccess is USER_PERMISSION.ACCESS.READONLY then 1 else 0

          if not view.isSupportUser and view.useInviteSystem
            Invites.createInvite(view.userData)
              .then (response) ->
                view.loading = false
                notification.success(null, notificationMessages.success, "invite-user", { dismissable: true, bindHtml: true }, 5)
              .catch ({error}) ->
                view.loading = false
                notification.error(null, notificationMessages.error, "invite-user", { dismissable: true, bindHtml: true }, 5)
          else
            if view.userData and view.userData.access_groups?
              res_access_groups = view.userData.access_groups
            else
              res_access_groups = null
            userService.save({
              name: view.userName,
              email: view.userData.email,
              is_admin: view.selectedAccess is USER_PERMISSION.ACCESS.ADMIN,
              is_billing: !!view.userData.client_rights.billing,
              is_technical: !!view.userData.client_rights.technical,
              is_readonly: view.selectedAccess is USER_PERMISSION.ACCESS.READONLY,
              sendNewUserEmail: true,
              clone_user: false
              access_groups: res_access_groups
            })
            .then (result) ->
              view.loading = false
              _initNewUserInfo()
              notification.success(null, notificationMessages.success, "invite-user", { dismissable: true, bindHtml: true }, 5)
            .catch ({data}) ->
              view.loading = false
              errorMessage = data.error
              if Array.isArray(data.error)
                errorMessage = data.error[0]?.email or notificationMessages.error

              notification.error(null, errorMessage, "invite-user", { dismissable: true, bindHtml: true }, 5)

        # $scope.view ?= {}
        $scope.option ?= {}
        $scope.option.userGroup ?= {}
        $scope.view.storeSelect ?= []
        allSelected = true

        fetchOptionsFromAPI = ->
          allStores = []
          userService.stores({clientId: view.clientId}).then (response) ->
            allStores = response.data

            groupData = []
            storeData = []
            for userGroup in allStores
              # Add to group data
              groupData.push({ id: userGroup.id, name: userGroup.name })
              for store in userGroup.stores
                storeData.push({ id: store.id, name: store.name, groupId: userGroup.id, selected: false })
            
            view.groupSelect = groupData
            view.storeSelect = storeData

            #for default option
            defaultGroup = groupData.find (group) -> group.id == 0
            if defaultGroup
              $scope.option.userGroup = defaultGroup
              $scope.updateFilteredStoreSelect(defaultGroup.id)

          , (error) ->
            notification.error("Server Error",
              errorConstants.SERVER_ERROR_MESSAGE,
              "manage-users",
              null,
              15
            )
        # Function to update the filtered store list based on the selected user group
        $scope.updateFilteredStoreSelect = (groupId) ->
          $scope.view.filteredStoreSelect = $scope.view.storeSelect.filter (store) ->
            store.groupId == groupId

        # Function to save selected group access
        saveSelectedGroupAccess = ->
          groupedStores = {}
          mainGroupId = $scope.option.userGroup.id

          # Initialize the main group in groupedStores
          groupedStores = {
            id: mainGroupId,
            stores: []
          }
          # Track if any store is unselected
          for store in $scope.view.storeSelect
            if store.groupId == mainGroupId
              if store.selected
                groupedStores.stores.push(store.id)
              else
                allSelected = false

          for store in $scope.view.storeSelect
            if store.groupId != mainGroupId and store.selected
              allSelected = false
              groupedStores.stores.push(store.id)

          if allSelected
            groupedStores.stores = []

          $scope.view.userData.access_groups = groupedStores
        

        # Watch for changes in selected user group to update store selections
        $scope.$watch('option.userGroup', (newVal) ->
          if newVal
            groupId = newVal.id
            $scope.updateFilteredStoreSelect(groupId)
            for store in $scope.view.storeSelect
              store.selected = store.groupId == groupId
            saveSelectedGroupAccess()
        , true)
        # Watch for changes in store selection to update selected group access
        $scope.$watch('view.storeSelect', (newVal) ->
          saveSelectedGroupAccess()
        , true)
         # Dropdown functionality
        searchInput = document.querySelector(".search-input")
        dropdownList = document.querySelector(".dropdown-list")
        if searchInput and dropdownList
          options = dropdownList.querySelectorAll("li")
          searchInput.addEventListener("input", () ->
            searchTerm = searchInput.value.toLowerCase()
            options = dropdownList.querySelectorAll("li")
            options.forEach((option) ->
              optionText = option.textContent.toLowerCase()
              if optionText.includes(searchTerm)
                option.style.display = "flex"
              else
                option.style.display = "none"
            )
          )

          document.addEventListener("click", (event) ->
            if not (event.target is searchInput)
              dropdownList.style.display = "none"
          )

          searchInput.addEventListener("click", () ->
            dropdownList.style.display = "block"
          )

          options.forEach((option) ->
            option.addEventListener("click", () ->
              searchInput.value = option.textContent
              dropdownList.style.display = "none"
            )
          )

       

        view.$postLink = () ->
          _init()

        view
    ]

]